import * as React from 'react';
import styled from '@emotion/styled';
import { skeletonLoadingImage } from '../../../helpers/animation.js';

var Flag = function (_a) {
    var code = _a.code;
    var _b = React.useState(null), FlagComp = _b[0], setFlagComp = _b[1];
    React.useEffect(function () {
        import('./all.js').then(function (Flags) {
            if (Flags[code]) {
                setFlagComp(Flags[code]);
            }
        });
    }, [code]);
    return FlagComp ? React.createElement(FlagComp, null) : React.createElement(FlagPlaceholder, null);
};
var FlagPlaceholder = styled.div(skeletonLoadingImage, {
    width: 24,
    height: 24,
    borderRadius: "50%",
});

export { FlagPlaceholder, Flag as default };
//# sourceMappingURL=Flag.js.map
